import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportCompComponent } from './report.component';

const routes: Routes = [
  { path: '', component: ReportCompComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportRoutingModule { }
